import React from "react";
import userDetailStore, { mailSuccessStore } from "../../config/store";
import $ from "jquery";
import { imgBaseUrl, detailsPageBaseUrl } from "../../utils/url";
import { onSocialShareCT, postData } from "../../utils/helper";
import { showCongratulations } from "../../utils/misc";

class CommonEmailBtn extends React.Component {
  constructor() {
    super();
    this.state = {
      email:
        userDetailStore.getState().userDetail &&
        userDetailStore.getState().userDetail["user_email"],
    };
  }

  emailvalidate = () => {
    var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (filter.test(this.state.email)) {
      var email = this.state.email;
      $(".send_email_button").find("img").removeClass("disabled");
      return true;
    } else {
      $(".send_email_button").find("img").addClass("disabled");
      //swal( "Invalid Email !" );
      return false;
    }
  };
  sendEmail = () => {
    this.props.handleLoader(true);
    if (this.state.email) {
      const { pageData, module_name } = this.props;

      let detailurl = detailsPageBaseUrl;
      if (module_name) {
        detailurl += module_name;
      }

      var params = {};
      if (this.emailvalidate()) {
        params["email"] = this.state.email;
        params["module_subtype"] = this.props.module_name; //sub module

        mailSuccessStore.dispatch({
          type: "SET_SUCCESS",
          data: { isLoading: true },
        });
        postData(params, "sendmail").done((data) => {
          if (data._resultflag === "1") {
            this.setState(
              {
                showThankYouPopUp: true,
                isLoading: false,
                sendEmail: this.state.email,
              },
              () => {
                let text = pageData.description ? pageData.description : "";
                let title = pageData.name ? pageData.name : "";
                title = pageData.inner_name ? pageData.inner_name : title;
                let template_url = pageData.template_url;

                onSocialShareCT({
                  type: "mail",
                  shareurl: detailurl,
                  text,
                  module: module_name ? module_name : "",
                  image: template_url,
                });
                showCongratulations(module_name);
              }
            );
          }
          this.setState({ isLoading: false });
        });
        mailSuccessStore.dispatch({
          type: "SET_SUCCESS",
          data: { isLoading: false, showThankYouPopUp: true, email: this.state.email },
        });
      }
      this.props.handleLoader(false);
    } else {
      this.props.handleLoader(false);

      alert("Please fill your email.");
    }
  };

  render() {
    const { email } = this.state;

    return (
      <React.Fragment>
        <div onClick={this.sendEmail}>{this.props.children}</div>

        <div className="email_div">
          <p>
            <label>Your email *</label>
          </p>
          <input
            type="text"
            value={email}
            placeholder="Email"
            onChange={(e) => {
              this.setState({ email: e.target.value });
            }}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default CommonEmailBtn;
